import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';

// @TODO: Perhaps this should be for project/task once refactored and just be reused
const url = `${PREFIX_URL}/task`;

type TaskCountersResponse = {
  result: any;
  count: {
    total_count: number;
  };
};

export const getTaskCounters = (params): Promise<TaskCountersResponse> => {
  return axios.get(url, {
    params: params,
  });
};

export const filterCounterKeys = {
  list: ['taskCounters'] as const,
};

type QueryFnType = typeof getTaskCounters;

type useTaskCounters = {
  projectId: string;
  page: number;
  limit: number;
  status: any;
  userId?: number;
  type?: string;
  dueDate?: string;
  config?: QueryConfig<QueryFnType>;
};

export const useTaskCounters = ({ projectId, config, ...otherParams }: useTaskCounters) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...filterCounterKeys.list, projectId, otherParams],
    queryFn: () => getTaskCounters({ projectId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
